import PropTypes from "prop-types";

import styles from "./styles.module.css";

const ProjectIntroduction = ({ introTitle, introText }) => (
  <div className={styles.wrapper}>
    <h2 className={styles.title}>{introTitle && introTitle}</h2>
    <div className={styles.description} dangerouslySetInnerHTML={{ __html: introText }} />
  </div>
);

ProjectIntroduction.propTypes = {
  introTitle: PropTypes.string,
  introText: PropTypes.string,
};

export default ProjectIntroduction;
